import * as React from "react"
import { cn } from "../../lib/utils"

const Toggle = React.forwardRef(({ className, checked, onCheckedChange, disabled, ...props }, ref) => {
  return (
    <label className={cn(
      "relative inline-flex items-center flex-shrink-0",
      disabled ? "cursor-not-allowed opacity-50" : "cursor-pointer"
    )}>
      <input
        type="checkbox"
        checked={checked}
        onChange={(e) => onCheckedChange?.(e.target.checked)}
        className="sr-only peer"
        disabled={disabled}
        ref={ref}
        {...props}
      />
      <div className={cn(
        "w-11 h-6 bg-toggle-bg rounded-full peer transition-colors duration-200",
        "peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-ring/20",
        "peer-checked:bg-toggle-checked",
        "after:content-[''] after:absolute after:top-[2px] after:left-[2px]",
        "after:bg-toggle-thumb after:border-toggle-border after:border",
        "after:rounded-full after:h-5 after:w-5 after:transition-all",
        "peer-checked:after:translate-x-full peer-checked:after:border-white",
        className
      )} />
    </label>
  )
})
Toggle.displayName = "Toggle"

export { Toggle }
